  export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login.vue"),
    meta: {
      title: "登录",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/pages/search.vue"),
    meta: {
      title: "搜索",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/view404",
    name: "404",
    component: () => import("@/pages/view404.vue"),
    meta: {
      title: "404",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/view403",
    name: "403",
    component: () => import("@/pages/view403.vue"),
    meta: {
      title: "403",
      displayable: false, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      hideNav: true,
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/pages/home.vue"),
    meta: {
      title: "首页",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive生成记录
    },
  },
  {
    path: "/class",
    name: "class",
    component: () => import("@/pages/class.vue"),
    meta: {
      title: "课程管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive生成记录
    },
  },
  {
    path: "/meet",
    name: "meet",
    component: () => import("@/pages/orderpointgood.vue"),
    meta: {
      title: "学员管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/activity",
    name: "activity",
    component: () => import("@/pages/activity.vue"),
    meta: {
      title: "单位管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/zuti",
    name: "zuti",
    component: () => import("@/pages/zuti.vue"),
    meta: {
      title: "主题管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/gonggao",
    name: "gonggao",
    component: () => import("@/pages/gonggao.vue"),
    meta: {
      title: "公告管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/baoming",
    name: "baoming",
    component: () => import("@/pages/baoming.vue"),
    meta: {
      title: "报名课程管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
  {
    path: "/baominguser",
    name: "baominguser",
    component: () => import("@/pages/baominguser.vue"),
    meta: {
      title: "报名学员管理",
      displayable: true, //是否为可显示页面
      isUseCache: false, // 默认不缓存
      keepAlive: true, // 是否使用 keep-alive
    },
  },
];
